export const ROUTES = {
    chooseDebitAccount: '/velg-betalingskonto',
    chooseAgreements: '/velg-avtalegiro',
    summary: '/oppsummering',
};

export default ROUTES;
